import React, { useState, useEffect } from 'react';
import { Layout } from 'antd';
import { Outlet, useLocation } from 'react-router-dom';
import { useIsMobile } from '@/hooks/useIsMobile';
import AppSidebar from './AppSidebar';
import AppHeader from './AppHeader';

declare global {
  interface Window {
    __OPS_MODE__?: boolean;
  }
}

const { Content } = Layout;

const pageTitleMap: Record<string, string> = {
  '/': '山东大盘',
  '/public': '山东大盘',
  '/private': '场站运营',
  '/revenue': '场站收益测算',
  '/agc-storage': 'AGC 配储测算',
  '/settlement': '结算驾驶舱',
  '/rt-price': '实时临时电价',
  '/upload': '场站数据上传',
  '/workbench': '交叉分析工作台',
  '/bess': 'BESS 概览',
  '/pv-daily': 'PV 日收益',
  '/city-capacity-3d': '新能源装机空间态势',
};

const AppLayout: React.FC = () => {
  const location = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);
  const isMobile = useIsMobile();
  const isOps = window.__OPS_MODE__ === true;

  useEffect(() => {
    document.title = isOps ? '场站运维中台' : '山东电力现货与运营综合中台';
  }, [isOps]);

  const pageTitle = pageTitleMap[location.pathname] || (isOps ? '场站运维' : '电力中台');
  const siderWidth = isMobile ? 0 : 220;

  return (
    <Layout className="app-layout" style={{ minHeight: '100vh' }}>
      <AppSidebar
        isMobile={isMobile}
        mobileOpen={mobileOpen}
        immersive={false}
        onMobileClose={() => setMobileOpen(false)}
      />
      <Layout className="app-layout__inner" style={{ marginLeft: siderWidth, transition: 'margin-left 0.2s' }}>
        <AppHeader
          pageTitle={pageTitle}
          immersive={false}
          onMenuClick={isMobile ? () => setMobileOpen(true) : undefined}
        />
        <Content className="app-layout__content">
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};

export default AppLayout;
